/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { Select } from 'sarsaparilla';
import { BLACKWATER_TURKEY_ID } from 'ui-permit/src/constants';

export default function HuntType({
    isLabelVisible = true,
    permitTypesList = [],
    permitID = '',
    value,
    onChange,
}) {
    if (!permitTypesList) {
        return [];
    }

    const optionsToShow = permitTypesList.reduce((filtered, permitType) => {
        if (
            permitID === BLACKWATER_TURKEY_ID &&
            permitType.id.includes('lottery') &&
            !permitType?.disabled
        ) {
            return filtered;
        }

        if (!permitType?.disabled) {
            filtered.push({ value: permitType.id, label: permitType.name });
        }
        return filtered;
    }, []);
    return (
        <Select
            isRequired
            isLabelVisible={isLabelVisible}
            label="Hunt Type"
            id="hunt-type"
            placeholder="Choose hunt type"
            options={optionsToShow}
            onChange={({ target: { value: v } }) => onChange(v)}
            value={value}
        />
    );
}

HuntType.propTypes = {
    isLabelVisible: PropTypes.bool,
    permitID: PropTypes.string,
    permitTypesList: PropTypes.any,
    value: PropTypes.string,
    onChange: PropTypes.func,
};
